import classNames from "classnames";
import Styles from "./System.module.scss";
import repairImg from "../../assets/images/SystemRepair.png";
const Repair = () => {
  /**
   * useEffect
   */

  // useEffect(() => {
  //   localStorage.clear();
  // }, []);

  // useEffect(() => {
  //   recaptchaRef.current.reset();
  // }, [isZeroModalOpen, isNotFoundModalOpen]);

  return (
    <div className={classNames(Styles.repair)}>
      <div className={classNames("container")}>
        <div>
          <img className={classNames(Styles.repair__img)} src={repairImg} alt="維修機器人.png"/>
          <div className={classNames(Styles.repair__words)}>系統維修中，造成您的困擾敬請見諒。</div>
        </div>
      </div>
    </div>
  );
};
export default Repair;
